export function copyToClipboard(text: string) {
  const fakeElement = document.createElement('input');
  document.body.appendChild(fakeElement);

  fakeElement.value = text;
  fakeElement.select();

  document.execCommand('copy');

  fakeElement.blur();
  document.body.removeChild(fakeElement);
}
